import { createFileRoute } from '@tanstack/react-router'
import ActivityContainer from 'Work/containers/ActivityContainer'

export const Route = createFileRoute('/work/$workId/launch-plan/activity/$activityId')({
    component: ActivityContainer,
})
